import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=50068085&scoped=true&"
import script from "./dropdown.vue?vue&type=script&lang=js&"
export * from "./dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50068085",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50068085')) {
      api.createRecord('50068085', component.options)
    } else {
      api.reload('50068085', component.options)
    }
    module.hot.accept("./dropdown.vue?vue&type=template&id=50068085&scoped=true&", function () {
      api.rerender('50068085', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/abstracts/dropdown.vue"
export default component.exports